var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "h-[500px] overflow-y-auto" },
      [
        _c(
          "el-form",
          {
            ref: "pram",
            attrs: { model: _vm.pram, "label-width": "75px" },
            nativeOn: {
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c("el-divider", { attrs: { "content-position": "left" } }, [
              _vm._v("商品成本项设置"),
            ]),
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "平台服务费：",
                          "label-width": "100px",
                          prop: "platformServiceFee",
                        },
                      },
                      [
                        _c(
                          "el-input",
                          {
                            attrs: {
                              readonly: _vm.isCreate === 2,
                              type: "number",
                              placeholder: "平台服务费",
                            },
                            model: {
                              value: _vm.pram.platformServiceFee,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.pram,
                                  "platformServiceFee",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "pram.platformServiceFee",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("%")])],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "商品运营费：",
                          "label-width": "100px",
                          prop: "productOperationFee",
                        },
                      },
                      [
                        _c(
                          "el-input",
                          {
                            attrs: {
                              readonly: _vm.isCreate === 2,
                              type: "number",
                              placeholder: "商品运营费",
                            },
                            model: {
                              value: _vm.pram.productOperationFee,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.pram,
                                  "productOperationFee",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "pram.productOperationFee",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("%")])],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "商城基本毛利：",
                          "label-width": "100px",
                          prop: "mallBasicProfit",
                        },
                      },
                      [
                        _c(
                          "el-input",
                          {
                            attrs: {
                              readonly: _vm.isCreate === 2,
                              type: "number",
                              placeholder: "商城基本毛利",
                            },
                            model: {
                              value: _vm.pram.mallBasicProfit,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.pram,
                                  "mallBasicProfit",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "pram.mallBasicProfit",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("%")])],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "其他费用：",
                          "label-width": "100px",
                          prop: "otherFee",
                        },
                      },
                      [
                        _c(
                          "el-input",
                          {
                            attrs: {
                              readonly: _vm.isCreate === 2,
                              type: "number",
                              placeholder: "其他费用",
                            },
                            model: {
                              value: _vm.pram.otherFee,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.pram,
                                  "otherFee",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "pram.otherFee",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("%")])],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "text-red-500 mb-8" }, [
              _vm._v(
                " 注：费用金额 = 商品售价 × 费用比例。 商品售价为上架设置的出售价，而不是用户实际支付金额。 "
              ),
            ]),
            _c("el-divider", { attrs: { "content-position": "left" } }, [
              _vm._v("0账期金额阈值"),
            ]),
            _c(
              "el-row",
              { staticClass: "mt-8" },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "0账期金额阈值",
                          "label-width": "100px",
                          prop: "accountThreshold",
                        },
                      },
                      [
                        _c(
                          "el-input",
                          {
                            attrs: {
                              readonly: _vm.isCreate === 2,
                              type: "number",
                              placeholder: "0账期金额阈值",
                            },
                            model: {
                              value: _vm.pram.accountThreshold,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.pram,
                                  "accountThreshold",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "pram.accountThreshold",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("元")])],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "账期天数",
                          "label-width": "100px",
                          prop: "accountPeriodDays",
                        },
                      },
                      [
                        _c(
                          "el-input",
                          {
                            attrs: {
                              readonly: _vm.isCreate === 2,
                              type: "number",
                              placeholder: "账期天数",
                            },
                            model: {
                              value: _vm.pram.accountPeriodDays,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.pram,
                                  "accountPeriodDays",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "pram.accountPeriodDays",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("天")])],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "text-red-500 mb-8" }, [
              _vm._v(
                "注：0账期金额阈值：商户0账期内可用最大金额，超过该金额就按照账期天数进行回账。"
              ),
            ]),
            _vm.isCreate !== 2
              ? _c(
                  "div",
                  { staticClass: "mt-8 mb-8" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.togglehideDialog()
                          },
                        },
                      },
                      [_vm._v("新增配置")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-table",
              { attrs: { data: _vm.listData, size: "small", sortable: "" } },
              [
                _c("el-table-column", {
                  attrs: { type: "index", width: "50" },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "商户名称",
                    prop: "realName",
                    "min-width": "130",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "商户姓名",
                    prop: "name",
                    "min-width": "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "商户手机号",
                    prop: "phone",
                    "min-width": "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "商户类型",
                    prop: "merchantTypeName",
                    "min-width": "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "店铺类型",
                    prop: "merchantTypeName",
                    "min-width": "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "状态", prop: "isSwitch", "min-width": "50" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(scope.row.isSwitch ? "启用" : "禁用") +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm.isCreate !== 2
                  ? _c("el-table-column", {
                      attrs: { label: "操作", width: "50", fixed: "right" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-popconfirm",
                                  {
                                    attrs: { title: "确认移除该商户吗？" },
                                    on: {
                                      confirm: function ($event) {
                                        return _vm.removeRow(scope.$index)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "hasPermi",
                                            rawName: "v-hasPermi",
                                            value: [
                                              "platform:admin:role:update",
                                            ],
                                            expression:
                                              "['platform:admin:role:update']",
                                          },
                                        ],
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      [_vm._v("移除")]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1097512252
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                staticClass: "dialog-bottom",
                attrs: {
                  visible: _vm.chooseMerchantVisible,
                  title: "商户选择",
                  "append-to-body": "",
                  "destroy-on-close": "",
                  "close-on-click-modal": false,
                  width: "840px",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.chooseMerchantVisible = $event
                  },
                },
              },
              [
                _vm.chooseMerchantVisible
                  ? _c("chooseMerchant", {
                      ref: "chooseMerchant",
                      on: {
                        hideMerchantDialog: _vm.togglehideDialog,
                        submitMerchantList: _vm.getMerchantList,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "dialog-footer-inner mt-14",
        attrs: { slot: "footer" },
        slot: "footer",
      },
      [
        _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
        _vm.isCreate !== 2
          ? _c(
              "el-button",
              {
                directives: [
                  {
                    name: "hasPermi",
                    rawName: "v-hasPermi",
                    value: [
                      "platform:admin:role:update",
                      "platform:admin:role:save",
                    ],
                    expression:
                      "['platform:admin:role:update', 'platform:admin:role:save']",
                  },
                ],
                attrs: { type: "primary" },
                on: { click: _vm.handlerSubmit },
              },
              [_vm._v(" " + _vm._s(_vm.isCreate === 0 ? "确定" : "更新"))]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }